import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Spinner/sgds-spinner";
import { register } from "../../utils/ce-registry";

register("sgds-spinner", Component);

export default createComponent({
  react: React,
  tagName: "sgds-spinner",
  elementClass: Component,
  events: {}
});
